(function () {
    "use strict";

    function loginRedirect($q, $location, $log) {

        var redirectPath;

        var responseError = function (response) {
            if (response.status === 401) {
                $log.debug("loginRedirect: responseError 401. Redirecting to login");
                redirectPath = $location.path();
                $location.path("/login");
            }
            return $q.reject(response);
        };

        var redirectUnauthorizedNavigationFrom = function (path) {
            if (path) {
                redirectPath = path;
            }
            return $q.when();
        };

        var redirectPostLogin = function (path) {
            $log.debug("loginRedirect: redirectPostLogin. saved: " + redirectPath + ", default: " + path);
            if (redirectPath && redirectPath !== "/login") {
                $location.path(redirectPath);
            } else {
                var redirect = path || "/";
                $location.path(redirect);
            }
        };

        return {
            responseError: responseError,
            redirectUnauthorizedNavigationFrom: redirectUnauthorizedNavigationFrom,
            redirectPostLogin: redirectPostLogin
        };
    }

    loginRedirect.$inject = ["$q", "$location", "$log"];

    angular.module("sphForms.auth")
        .factory("sphForms.loginRedirect", loginRedirect);

})();
